import Categories from './categories';

// 这里原本是 dynamic(..., { ssr: false }) + react-lazyload：
// Googlebot 渲染时不滚动页面，once 的 LazyLoad 永远不触发，首页分类区（含全部分类
// 链接）在 Google 看到的 HTML 里始终只是一个空占位块 —— GSC「测试实际网址」的渲染
// 截图可见整片空白。分类页因此只能靠 sitemap 被发现，没有任何内链支撑，长期停在
// 「已发现 - 尚未编入索引」。
//
// 改为正常服务端渲染。图片本身已经是 loading="lazy"（见 categories.js），所以去掉
// 组件级懒加载不会让图片提前下载，首屏网络请求不变；同时少了一个动态 chunk 的往返，
// 也不再有占位块高度与实际内容不一致带来的 CLS。
const CategoriesLazyLoad = () => {
  return <Categories />;
};

export default CategoriesLazyLoad;
